import { render, staticRenderFns } from "./original-email-message.vue?vue&type=template&id=6c20d1aa&scoped=true"
import script from "./original-email-message.vue?vue&type=script&lang=js"
export * from "./original-email-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c20d1aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c20d1aa')) {
      api.createRecord('6c20d1aa', component.options)
    } else {
      api.reload('6c20d1aa', component.options)
    }
    module.hot.accept("./original-email-message.vue?vue&type=template&id=6c20d1aa&scoped=true", function () {
      api.rerender('6c20d1aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/original-email-message.vue"
export default component.exports